import { handleActions } from 'redux-actions';
import moment from 'moment';

import { types, inputFieldNames } from '../constants';
import { getUniqueArray } from './../utils/attachmentUtils';

const INITIAL_STATE = {
  newEvent: {
    showCreateEventDialog: false,
    showEditEventPanel: false,
    showEditEventDialog: false,
    item: {
      lastHeldDateUTC: null,
      nextEventDateUTC: null
    },
    isSaving: false,
    errorMessage: ''
  },
  event: {
    item: null,
    isLoading: false,
    errorMessage: ''
  },
  newRecord: {
    item: {
      recordDate: null,
      notes: '',
      attachmentFiles: [],
      existingAttachmentFiles: []
    },
    isSaving: false,
    errorMessage: '',
    openAddEventRecordDialog: false
  },
  recordsForTheEvent: {
    items: [],
    isLoading: false,
    errorMessage: null
  },
  deleteRecord: {
    result: false,
    isSaving: false,
    errorMessage: null
  },
  editRecord: {
    enable: false,
    item: { attachmentFiles: [], existingAttachmentFiles: [] },
    isSaving: false,
    errorMessage: ''
  }
};

const openCreateEventDialog = (state, { open }) => {
  return {
    ...state,
    newEvent: {
      ...state.newEvent,
      showCreateEventDialog: open,
      item: {
        lastHeldDateUTC: null,
        nextEventDateUTC: null
      }
    }
  };
};

const openEditEventPanel = (state, { open }) => {
  return {
    ...state,
    newEvent: {
      ...state.newEvent,
      showEditEventPanel: open,
      item: {}
    }
  };
};

const openEditEventDialog = (state, { open }) => {
  return {
    ...state,
    newEvent: {
      ...state.newEvent,
      showEditEventDialog: open,
      item: {}
    }
  };
};

const inputChangeCreateEventForm = (state, { value, inputFieldName }) => {
  const event = { ...state.newEvent.item };
  const record = { ...state.newRecord.item };

  switch (inputFieldName) {
    case inputFieldNames.DESCRIPTION:
      event.description = value;
      break;
     case inputFieldNames.EVENT_NOTES:
       event.notes = value;
       break;
    case inputFieldNames.FREQUENCY:
      event.frequency = Number(value);
      break;
    case inputFieldNames.EVENT_TYPE:
      event.eventTypeId = value;
      break;
    case inputFieldNames.EVENT_COORDINATOR:
      event.eventCoordinator = value;
      break;
    case inputFieldNames.EVENT_DOCUMENT_NAME:
      event.document = value;
      break;
    // case inputFieldNames.LAST_HELD_DATE:
    //   event.lastHeldDateUTC = value;
    //   break;
    // case inputFieldNames.NEXT_EVENT_DATE:
    //   event.nextEventDateUTC = value;
    //   break;
    case inputFieldNames.RECORD_DATE:
      var newDate = moment(value).local().format('YYYY-MM-DD');
      record.recordDate = newDate;
      break;
    case inputFieldNames.RECORD_NOTES:
      record.notes = value;
      break;
    case inputFieldNames.EVENT_RECORD_ATTACHMENT:
      if (!record.attachmentFiles) {
        record.attachmentFiles = [];
      }
      record.attachmentFiles.push(value);
      var filteredArray = getUniqueArray(record.attachmentFiles);
      record.attachmentFiles = filteredArray;
      break;
    default:
  }

  return {
    ...state,
    newEvent: {
      ...state.newEvent,
      item: event
    },
    newRecord: {
      ...state.newRecord,
      item: record
    }
  };
};

const startSubmitEvent = (state) => {
  return {
    ...state,
    newEvent: {
      ...state.newEvent,
      isSaving: true
    }
  };
};

const submitEventSuccess = (state, { submittedEvent }) => {
  return {
    ...state,
    event: {
      ...state.event,
      item: submittedEvent
    }
  };
};

const submitEventFailure = (state, { errorMessage }) => {
  return {
    ...state,
    newEvent: {
      ...state.newEvent,
      errorMessage
    }
  };
};

const submitEventFinished = (state) => {
  return {
    ...state,
    newEvent: {
      ...state.newEvent,
      isSaving: false
    }
  };
};

const editEvent = (state, { event }) => {
  return {
    ...state,
    newEvent: {
      ...state.newEvent,
      item: event
    }
  };
};

const startFetchRecordsForTheEvent = (state) => {
  return {
    ...state,
    recordsForTheEvent: {
      ...state.recordsForTheEvent,
      isLoading: true
    }
  };
};

const fetchRecordsForTheEventSuccess = (state, { records }) => {
  return {
    ...state,
    recordsForTheEvent: {
      ...state.recordsForTheEvent,
      items: records
    }
  };
};

const fetchRecordsForTheEventFailure = (state, { errorMessage }) => {
  return {
    ...state,
    recordsForTheEvent: {
      ...state.recordsForTheEvent,
      errorMessage
    }
  };
};

const fetchRecordsForTheEventFinished = (state) => {
  return {
    ...state,
    recordsForTheEvent: {
      ...state.recordsForTheEvent,
      isLoading: false
    }
  };
};

const startDeleteEventRecord = (state) => {
  return {
    ...state,
    deleteRecord: {
      ...state.deleteRecord,
      isSaving: true
    }
  };
};

const deleteEventRecordSuccess = (state, { recordId }) => {
  let records = [...state.recordsForTheEvent.items];
  let deleteIndex = records.findIndex((r) => r.id === recordId);

  if (deleteIndex !== -1) {
    records.splice(deleteIndex, 1);
  }

  return {
    ...state,
    deleteRecord: {
      ...state.deleteRecord
    },
    recordsForTheEvent: {
      ...state.recordsForTheEvent,
      items: records
    }
  };
};

const deleteEventRecordFailure = (state, { errorMessage }) => {
  return {
    ...state,
    deleteRecord: {
      ...state.deleteRecord,
      errorMessage
    }
  };
};

const deleteEventRecordFinished = (state) => {
  return {
    ...state,
    deleteRecord: {
      ...state.deleteRecord,
      isSaving: false
    }
  };
};

const startSubmitEventRecord = (state) => {
  return {
    ...state,
    newRecord: {
      ...state.newRecord,
      isSaving: true
    }
  };
};

const submitEventRecordSuccess = (state) => {
  return {
    ...state,
    newRecord: {
      ...state.newRecord,
      item: {
        recordDate: null,
        notes: ''
      }
    }
  };
};

const submitEventRecordFailure = (state, { errorMessage }) => {
  return {
    ...state,
    newRecord: {
      ...state.newRecord,
      errorMessage
    }
  };
};

const submitEventRecordFinished = (state) => {
  return {
    ...state,
    newRecord: {
      ...state.newRecord,
      isSaving: false
    }
  };
};

const enableEditEventRecord = (state, { enableEditRecordMode, recordId }) => {
  const record = state.recordsForTheEvent.items.filter(
    (r) => r.id === recordId
  )[0];

  return {
    ...state,
    editRecord: {
      ...state.editRecord,
      enable: enableEditRecordMode,
      item: record
    }
  };
};

const inputChangeEditEventRecord = (state, { value, inputFieldName }) => {
  const record = { ...state.editRecord.item };

  switch (inputFieldName) {
    case inputFieldNames.RECORD_DATE:
      var newDate = moment(value).local().format('YYYY-MM-DD');
      record.recordDate = newDate;
      break;
    case inputFieldNames.RECORD_NOTES:
      record.notes = value;
      break;
    case inputFieldNames.EVENT_RECORD_ATTACHMENT:
      if (!record.attachmentFiles) {
        record.attachmentFiles = [];
      }
      record.attachmentFiles.push(value);
      var filteredArray = getUniqueArray(record.attachmentFiles);
      record.attachmentFiles = filteredArray;
      break;
    default:
  }

  return {
    ...state,
    editRecord: {
      ...state.editRecord,
      item: record
    }
  };
};

const openAddEventRecordDialog = (state, { open }) => {
  return {
    ...state,
    newRecord: {
      ...state.newRecord,
      openAddEventRecordDialog: open
    }
  };
};

const startLoadAttachmentsForEventRecord = (state) => {
  return {
    ...state,
    editRecord: {
      ...state.editRecord,
      isSaving: true
    }
  };
};

const loadAttachmentsForEventRecordSuccess = (state, { attachments }) => {
  var attachmentCustomObjets = [];

  for (let index = 0; index < attachments.length; index++) {
    const element = {
      id: attachments[index].id,
      newlyAdded: false,
      removed: false,
      fileData: null,
      name: attachments[index].fileName,
      url: attachments[index].url
    };
    attachmentCustomObjets.push(element);
  }

  return {
    ...state,
    editRecord: {
      ...state.editRecord,
      item: {
        ...state.editRecord.item,
        attachmentFiles: attachmentCustomObjets,
        existingAttachmentFiles: attachmentCustomObjets
      }
    }
  };
};

const loadAttachmentForEventRecordFailure = (state, { errorMessage }) => {
  return {
    ...state,
    editRecord: {
      ...state.editRecord,
      errorMessage
    }
  };
};

const loadAttachmentForEventRecordFinished = (state, { errorMessage }) => {
  return {
    ...state,
    editRecord: {
      ...state.editRecord,
      isSaving: false
    }
  };
};

const removeAttachment = (state, { attachment }) => {
  let record = state.newRecord.item;
  let remainingAttachements = record.attachmentFiles.filter(
    (item) => item.name !== attachment.name
  );
  record.attachmentFiles = remainingAttachements;
  return {
    ...state,
    newRecord: {
      ...state.newRecord,
      item: record
    }
  };
};

const removeAttachmentFromEditRecordMode = (state, { attachment }) => {
  let record = state.editRecord.item;
  let remainingAttachements = record.attachmentFiles.filter(
    (item) => item.name !== attachment.name
  );
  record.attachmentFiles = remainingAttachements;
  return {
    ...state,
    editRecord: {
      ...state.editRecord,
      item: record
    }
  };
};

//Handles the incoming actions.
export default handleActions(
  {
    [types.OPEN_CREATE_EVENT_DIALOG]: openCreateEventDialog,
    [types.OPEN_EDIT_EVENT_PANEL]: openEditEventPanel,
    [types.OPEN_EDIT_EVENT_DIALOG]: openEditEventDialog,
    [types.INPUT_CHANGE_CREATE_EVENT_FORM]: inputChangeCreateEventForm,

    [types.START_SUBMIT_EVENT]: startSubmitEvent,
    [types.SUBMIT_EVENT_SUCCESS]: submitEventSuccess,
    [types.SUBMIT_EVENT_FAILURE]: submitEventFailure,
    [types.SUBMIT_EVENT_FINISHED]: submitEventFinished,

    [types.EDIT_EVENT]: editEvent,

    [types.START_FETCH_RECORDS_FOR_THE_EVENT]: startFetchRecordsForTheEvent,
    [types.FETCH_RECORDS_FOR_THE_EVENT_SUCCESS]: fetchRecordsForTheEventSuccess,
    [types.FETCH_RECORDS_FOR_THE_EVENT_FAILURE]: fetchRecordsForTheEventFailure,
    [types.FETCH_RECORDS_FOR_THE_EVENT_FINISHED]: fetchRecordsForTheEventFinished,

    [types.START_DELETE_EVENT_RECORD]: startDeleteEventRecord,
    [types.DELETE_EVENT_RECORD_SUCCESS]: deleteEventRecordSuccess,
    [types.DELETE_EVENT_RECORD_FAILURE]: deleteEventRecordFailure,
    [types.DELETE_EVENT_RECORD_FINISHED]: deleteEventRecordFinished,

    [types.START_SUBMIT_EVENT_RECORD]: startSubmitEventRecord,
    [types.SUBMIT_EVENT_RECORD_SUCCESS]: submitEventRecordSuccess,
    [types.SUBMIT_EVENT_RECORD_FAILURE]: submitEventRecordFailure,
    [types.SUBMIT_EVENT_RECORD_FINISHED]: submitEventRecordFinished,

    [types.ENABLE_EDIT_EVENT_RECORD]: enableEditEventRecord,

    [types.INPUT_CHANGE_EDIT_EVENT_RECORD]: inputChangeEditEventRecord,

    [types.OPEN_ADD_EVENT_RECORD_DIALOG]: openAddEventRecordDialog,

    //Event Record Attachement
    [types.START_LOAD_ATTACHMENTS_FOR_EVENT_RECORD]: startLoadAttachmentsForEventRecord,
    [types.LOAD_ATTACHMENTS_FOR_EVENT_RECORD_SUCCESS]: loadAttachmentsForEventRecordSuccess,
    [types.LOAD_ATTACHMENTS_FOR_EVENT_RECORD_FAILURE]: loadAttachmentForEventRecordFailure,
    [types.LOAD_ATTACHMENTS_FOR_EVENT_RECORD_FINISHED]: loadAttachmentForEventRecordFinished,

    [types.REMOVE_EVENT_RECORD_ATTACHMENT]: removeAttachment,

    [types.REMOVE_EVENT_RECORD_ATTACHMENT_EDIT]: removeAttachmentFromEditRecordMode
  },
  INITIAL_STATE
);
